import {BLACK, DARK_GRAY, WHITE} from '../../../globalVariables/GlobalVariables';

export const getColor = (isDarkMode: boolean) => {
    return isDarkMode ? WHITE : BLACK;
};

export const getBackground = (isDarkMode: boolean) => {
    return isDarkMode ? DARK_GRAY : WHITE;
};
